<form>
  <div class="file-upload--drag-area" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
    <input class="file-upload--input" type="file" name="browsedFile" id="file" (change)="onFileBrowse($event)" />
    @if (!uploadedFile()) {
      <i class="fa fa-upload fa-5x p-3 text-muted"></i>
    } @else {
      <i class="fa fa-file-o fa-5x p-3 text-muted"></i>
    }
    <br />
    <label for="file" class="file-upload--label">
      @if (!uploadedFile()) {
        <strong class="underline" style="cursor: pointer">
          {{ 'upload_file.choose_files' | translate }}
        </strong>
        <span class="file-upload--drag-label ms-2">
          {{ 'upload_file.drag_file_here' | translate }}
        </span>
      }
    </label>
    @if (uploadedFile()) {
      <div class="file-upload--label">
        <i class="fa fa-check text-success"></i>
        <span class="file-upload--drag-label ms-2">{{ uploadedFile()?.name }}</span>
        <br />
        <strong class="underline" style="cursor: pointer" (click)="removeFile(false)">
          {{ 'upload_file.remove' | translate }}
        </strong>
      </div>
    }
  </div>
</form>
